var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.73125V9.25125C0.5 9.39125 0.61 9.50125 0.75 9.50125H2.27C2.335 9.50125 2.4 9.47625 2.445 9.42625L7.905 3.97125L6.03 2.09625L0.575 7.55125C0.525 7.60125 0.5 7.66125 0.5 7.73125ZM9.355 2.52125C9.55 2.32625 9.55 2.01125 9.355 1.81625L8.185 0.64625C7.99 0.45125 7.675 0.45125 7.48 0.64625L6.565 1.56125L8.44 3.43625L9.355 2.52125Z",
    fill: "#EEF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.db70e80af61452198854ce41ed89e37c.svg";
export { ForwardRef as ReactComponent };